import { getResourceList, patchResource } from '../util';

const resourceName = 'channels';

export const GET_CHANNEL_LIST = 'GET_CHANNEL_LIST';
export function getChannelList() {
  return getResourceList(GET_CHANNEL_LIST, resourceName);
}

export const TOGGLE_CHANNEL = 'TOGGLE_CHANNEL';
export function toggleChannel(
  channelId: string,
  teamId: string,
  active: boolean,
  options: any,
) {
  const path = `channels/${channelId}`;
  const payload = {
    team_id: teamId,
    is_active: active,
    ...options,
  };

  return patchResource(TOGGLE_CHANNEL, resourceName, path, payload);
}
